import { RecurrenceType, StaffSchedule } from "@/types/staff-schedule";
import { format } from "date-fns";
import { TFunction } from "i18next";

export function formatPattern(schedule: StaffSchedule, t: TFunction): string {
  if (schedule.recurrenceType === RecurrenceType.EVERY_N_DAYS) {
    const interval = schedule.recurrenceInterval ?? 1;
    if (interval === 1) {
      return t("staffSchedule.recurrence.everyDay");
    }
    return t("staffSchedule.recurrence.everyNDays", { count: interval });
  }

  const daysStr = schedule.days.join(", ");
  const type =
    schedule.recurrenceType === RecurrenceType.WEEKLY
      ? t("staffSchedule.recurrence.weekly")
      : t("staffSchedule.recurrence.biweekly");

  return `${daysStr} (${type})`;
}

export function formatEffectivePeriod(
  schedule: StaffSchedule,
  t: TFunction,
): string {
  const from = format(new Date(schedule.effectiveFrom), "MMM d, yyyy");
  if (!schedule.effectiveTo) {
    return `${from} – ${t("staffSchedule.table.ongoing")}`;
  }
  const to = format(new Date(schedule.effectiveTo), "MMM d, yyyy");
  return `${from} – ${to}`;
}

export function formatHours(schedule: StaffSchedule): string {
  return `${schedule.startTime} – ${schedule.endTime}`;
}
